import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
// import { emit } from 'process';
import { MatDialog } from '@angular/material/dialog';
import { MyModalComponent } from '../my-modal/my-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import { LoaderService } from '../../services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { after } from 'node:test';
// import { PaymentOptionComponent } from '../payment-option/payment-option.component';
// import { emit } from 'node:process';

@Component({
  selector: 'app-stpes',
  templateUrl: './stpes.component.html',
  styleUrl: './stpes.component.scss',
})
export class StpesComponent {
  @Output() sendUrl: EventEmitter<any> = new EventEmitter<void>();
  // @ViewChild(PaymentOptionComponent) paymentOption!: PaymentOptionComponent;
  // @Output() cartClickInCheckOut: EventEmitter<any> = new EventEmitter<void>();
  AddressId: any;
  isSelect = 'cart';
  cartData: any;
  addressDetails!: any[];
  addressDefult: any;
  addressIds: any;
  dataId: any;
  chackOutproduct: any;
  address_id: any;
  accept: any;
  imgUrlCart = environment.ImageBaseUrl;
  // paymentOption: any;
  payments1: any;
  couponCode: any;
  isCouponApplied: boolean = false;
  message: string = '';
  totalProducts: number = 0;
  shipingData: any;
  subTotal: any;
  discountPrice: any;
  newSubtotal: any;
  shippingcharge: any;
  isProcessing: boolean = false;
  paymentMethod: string = 'cod';
  discount: number = 0;
  mobileNumber: string = '6264305600';
  redirectUrl: string = 'https://vinmarts.in/order-sumamary';
  callbackUrl: string = 'https://vinmarts.in/payment-fail';
  paymentUrl: string = '';
  onlyOnce: boolean = false;
  sessionId: string = ''; // <-- add this at the top
  orderIdCashFree: any;
  cashFreeOrderId: any;
  selectOption: any;
  afterOnline: number;
  varinatColor: string | null = null;

  constructor(
    private api: ApiServiceService,
    public dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loader: LoaderService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
  ) {
    //  window.addEventListener('message', (event) => {
    //     console.log('ebeneen', event);
    //     if (event.origin === 'https://mercury-t2.phonepe.com') {
    //     // if (event.origin === 'https://mercury-uat.phonepe.com') {
    //       try {
    //         const decodedData = atob(event.data);
    //         const response = JSON.parse(decodedData);
    //         console.log('response', response);
    //         const isSuccess =
    //           response?.bridgeContext?.code === 'CONCLUDED' &&
    //           response?.bridgeContext?.bridgeType ===
    //             'BACK_TO_MERCHANT_CHECKOUT_JS';
    //         const isCancelled =
    //           response?.bridgeContext?.code === 'CANCELLED' &&
    //           response?.bridgeContext?.bridgeType ===
    //             'BACK_TO_MERCHANT_CHECKOUT_JS';
    //         if (isSuccess) {
    //           this.chackOut('prepaid');
    //         } else if (isCancelled) {
    //           window.location.href = 'https://vinmarts.in/payment-fail';
    //           // window.location.href = 'localhost:5000/payment-fail';
    //         } else {
    //           window.location.href = 'https://vinmarts.in/payment-fail';
    //           //  window.location.href = 'localhost:5000/payment-fail';
    //         }
    //       } catch (error) {
    //         console.error('Error decoding response:', error);
    //         window.location.href = 'https://vinmarts.in/payment-fail';
    //       }
    //     }
    //   });
  }

  ngOnInit() {
    this.loadCart();
    this.getAllUserAddress();
    this.applyCoupon();
  }

  // onSourceButtonClick(event: any): void {
  //   this.isSelect = event;
  //   this.chackOut(event);

  // }
  sendURL(event: any) {}

  receiveColor(color: string | null) {
    this.varinatColor = color;
    console.log('Selected color:', color);
  }

  selectPaymentOption(event: any) {
    this.selectOption = event;
    console.log('selectPaymentOption---option', this.selectOption);
    this.selectPayment(this.selectOption);
    if (this.selectOption === 'online') this.initiatePayment();
  }

  // loadCart() {
  //   const userId = this.getCurrentUserId();

  //   this.api.getCartList(userId).subscribe((data: any) => {
  //     this.shipingData = data.data;

  //     if (this.shipingData && this.shipingData.length > 0) {
  //       // Calculate subtotal with proper price resolution
  //       this.subTotal = this.shipingData.reduce((total: number, item: any) => {
  //         // ✅ Priority 1: attributeSize (size with custom price)
  //         let productPrice = 0;
  //         if (
  //           item.attributeSize &&
  //           typeof item.attributeSize === 'object' &&
  //           item.attributeSize.price != null
  //         ) {
  //           productPrice = Number(item.attributeSize.price);
  //         }
  //         // ✅ Priority 2: variantData (resolved by ID)
  //         else if (item.variantData) {
  //           const matchedVariant = item?.product_id?.variants?.find(
  //             (v: any) => v._id === item.variantData
  //           );
  //           if (matchedVariant?.sellingPrice) {
  //             productPrice = Number(matchedVariant.sellingPrice);
  //           } else {
  //             productPrice = Number(item?.product_id?.priceInventoryShippingInfo?.sellingPrice) || 0;
  //           }
  //         }
  //         // ✅ Fallback: base product price
  //         else {
  //           productPrice = Number(item?.product_id?.priceInventoryShippingInfo?.sellingPrice) || 0;
  //         }

  //         const productDiscount = 0; // or item.discount if supported
  //         const quantity = item.quantity || 1;

  //         const priceAfterDiscount = productPrice * (1 - productDiscount / 100);
  //         const itemTotal = priceAfterDiscount * quantity;

  //         return total + itemTotal;
  //       }, 0);

  //       console.log('subtotal', this.subTotal);

  //       // Re-apply coupon if one was entered
  //       if (this.couponCode) {
  //         this.applyCoupon();
  //       }

  //       this.cartData = this.shipingData;
  //       this.totalProducts = this.cartData.length;
  //     } else {
  //       this.totalProducts = 0;
  //       this.subTotal = 0;
  //     }
  //   });
  // }

  parseIfString(value: any) {
    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch {
        return null;
      }
    }
    return value;
  }

  loadCart() {
    const userId = this.getCurrentUserId();

    this.api.getCartList(userId).subscribe((res: any) => {
      this.shipingData = res.data || [];

      if (!this.shipingData.length) {
        this.subTotal = 0;
        this.totalProducts = 0;
        return;
      }

      this.subTotal = this.shipingData.reduce((total: number, item: any) => {
        let unitPrice = 0;

        const variant = this.parseIfString(item.variantData);
        const size = this.parseIfString(item.attributeSize);

        /* 1️⃣ Variant + Size price */
        if (variant && size?.price != null) {
          unitPrice = Number(size.price);
        } else if (variant?.sellingPrice != null) {

        /* 2️⃣ Variant selling price */
          unitPrice = Number(variant.sellingPrice);
        } else {

        /* 3️⃣ Base product price */
          unitPrice = Number(
            item.product_id?.priceInventoryShippingInfo?.sellingPrice || 0,
          );
        }

        return total + unitPrice * (item.quantity || 1);
      }, 0);

      console.log('✅ Cart Subtotal:', this.subTotal);

      // Re-apply coupon if exists
      if (this.couponCode) {
        this.applyCoupon();
      }

      this.cartData = this.shipingData;
      this.totalProducts = this.cartData.length;
    });
  }

  selectPayment(method: string) {
    return new Promise((resolve, reject) => {
      this.selectOption = method;

      this.newSubtotal = this.isCouponApplied
        ? this.subTotal - (method === 'Prepaid' ? 40 : 0)
        : this.subTotal - (method === 'Prepaid' ? 40 : 0);
      resolve(this.newSubtotal);
    });
    // If a coupon is applied, use the discounted price, otherwise use the normal subtotal
  }

  getAllUserAddress() {
    this.api.getAllUserAddress().subscribe((addressData: any) => {
      this.addressDetails = addressData.data;
      console.log('alladdd essss-->', this.addressDetails);
    });
  }

  async onButtonClick() {
    console.log('hhhhh', this.isSelect);
    if (!this.addressDetails || this.addressDetails.length === 0) {
      console.log('hhhhh');
      this.toastr.warning('Please add Address to place order');
      this.router.navigate(['/add-address'], {
        queryParams: { redirect: 'cart' },
      });
      return; // Stop checkout
    }
    this.addressDetails;
    this.isSelect = 'payment';
    console.log('hhhhh', this.isSelect);
    this.selectPayment(this.newSubtotal).then(() => {});
  }

  //  initiatePayment() {
  //     const phone = JSON.parse(this.mobileNumber)
  //     const payload = {
  //       amount: ((this.newSubtotal - (this.discountPrice || 0)) * 100) - (40 * 100),
  //       redirectUrl: this.redirectUrl,
  //       callbackUrl: this.callbackUrl,
  //       mobileNumber: phone,
  //     };

  //     this.api.initiatePayment(payload).subscribe(
  //       (response) => {
  //         if (response.paymentUrl && this.paymentUrl !== response.paymentUrl) {
  //           this.paymentUrl = response.paymentUrl;
  //           this.sendUrl.emit(this.paymentUrl);
  //           this.isSelect = 'payment';
  //           this.payments1 = this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentUrl)
  //           console.log('payent1----->', this.payments1)
  //         } else {
  //           alert('Payment initiation failed!');
  //         }
  //       },
  //       (error) => {
  //         console.error('Error:', error);
  //         alert('Payment initiation error!' );
  //       }
  //     );
  //   }

  // initiatePayment() {
  //   const payload = {
  //     orderId: "order_" + Date.now(),
  //     amount: this.newSubtotal - (this.discountPrice || 0),
  //     customerName: "User",
  //     customerEmail: "user@email.com",
  //     customerPhone: this.mobileNumber
  //   };

  //   this.api.createCashFreeOrder(payload).subscribe(
  //     (res: any) => {
  //       if (res.success) {
  //         this.sessionId = res.data.payment_session_id;
  //         this.isSelect = 'payment'; // show popup
  //   //  setTimeout(() => {
  //   //    this.startCashfreeCheckout(sessionId);
  //   //  }, 300);
  //       } else {
  //         this.toastr.error("Payment creation failed!");
  //       }
  //     },
  //     (err) => {
  //       console.error(err);
  //       this.toastr.error("Payment error!");
  //     }
  //   );
  // }

  getFinalAmount() {
    let amount = this.newSubtotal;

    // apply coupon discount
    if (this.discountPrice) {
      amount -= this.discountPrice;
    }

    // online discount
    if (this.selectOption === 'online') {
      amount -= 40;
    }

    return amount;
  }

  initiatePayment() {
    const finalAmount = this.getFinalAmount(); // ✅ always correct

    // const orderSplits = this.cartData.map(item => ({
    //   vendor_id: item.seller_id,               // Cashfree vendor ID
    //   amount: item.settlement?.netAmount || 0
    // }));

    const payload = {
      orderId: 'order_' + Date.now(),
      amount: finalAmount,
      customerName: this.addressDetails[0].user_id?.name,
      customerEmail: this.addressDetails[0].user_id?.email,
      customerPhone: this.addressDetails[0].user_id?.mobile,
      // orderSplits
    };

    this.api.createCashFreeOrder(payload).subscribe(
      (res: any) => {
        if (res.success) {
          this.sessionId = res.payment_session_id;
          this.cashFreeOrderId = res.order_id;
        } else {
          this.toastr.error('Payment creation failed!');
        }
      },
      (err) => {
        console.error(err);
        this.toastr.error('Payment error!');
      },
    );
  }

  // finalizeCheckoutAfterPayment() {
  //   // SAME PAYLOAD AS COD CHECKOUT
  //   const selectedAddress = this.addressDetails.find(
  //     (address) => address.isDefault === true
  //   );
  //   const addressId = selectedAddress ? selectedAddress._id : null;

  //   const payload = {
  //     address_id: addressId,
  //     payment_gateway: "ONLINE",
  //     accept: true,
  //     shipping_charge:
  //       this.cartData?.product_id?.priceInventoryShippingInfo?.sippingCharge || 0,
  //     coupon_amount: this.discountPrice,
  //     coupon_code: this.couponCode,
  //     direct_purchase: false,
  //     selected_items: this.cartData.map((item: any) => item.product_id._id),
  //   };

  //   this.loader.showLoader();

  //   this.api.chackOut(payload).subscribe((res: any) => {
  //     this.loader.hideLoader();

  //     if (res?.data?._id) {
  //       this.router.navigate(
  //         ['order-sumamary'],
  //         { queryParams: { id: res.data._id } }
  //       );
  //     } else {
  //       this.toastr.error("Failed to finalize order!");
  //     }
  //   });
  // }

  // startCashfreeCheckout(sessionId: string) {
  //   const cashfree = new Cashfree({ mode: "sandbox" }); // or production
  //   console.log("Got session ID:", sessionId);

  //   cashfree.checkout({
  //     paymentSessionId: sessionId,
  //     // redirectTarget: "_modal"
  //     redirectTarget: "cashfree-dropin"  // 👈 render inside this DIV
  //     // redirectTarget: "checkout"    // 👈 opens the payment UI popup
  //   });
  // }

  onCodSelected() {
    console.log('📦 COD selected — placing order without ₹40 deduction');
    this.chackOut('COD'); // ✅ backend should use full amount (subTotal - coupon only)
  }

  onPaymentSuccess(details: any) {
    console.log('✅ Online payment succeeded');
    this.chackOut('Prepaid'); // ✅ backend should use amount = subTotal - coupon - 40
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MyModalComponent, {
      width: '50%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getAllUserAddress();
    });
  }

  //  addressUpdate(){

  //   this.router.navigate(["/add-address"]);
  // }

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  updateCart() {
    this.loadCart();
  }

  payments() {
    this.isSelect = 'payment';
  }

  order() {
    this.isSelect = 'order';
  }

  applyCoupon() {
    const userId = this.getCurrentUserId();

    // Prepare the payload with the coupon code and user ID
    const para = {
      code: this.couponCode,
      userId: userId,
      productId: this.cartData[0].product_id?._id,
    };

    // Call API to apply the coupon
    this.api.applyCoupon(para).subscribe({
      next: (response: any) => {
        const coupondata = response;

        if (
          response &&
          response.discount !== undefined &&
          response.newPrice !== undefined
        ) {
          this.discountPrice = response.discount; // Discount amount
          this.newSubtotal = response.newPrice; // Subtotal after applying the coupon

          // Set success message and status
          this.isCouponApplied = true;
          this.message = `Coupon applied successfully! You saved ₹${this.discountPrice.toFixed(
            2,
          )}.`;
        } else {
          // Handle unexpected response
          this.isCouponApplied = false;
          this.message =
            'Invalid coupon or could not apply the coupon. Please try again.';
        }
      },
      error: (err: any) => {
        this.isCouponApplied = false;
        this.message =
          'Failed to apply coupon: ' +
          (err.error?.message || 'Invalid coupon code');
      },
    });
  }

  chackOut(paymentMethod: any) {
    if (this.isProcessing) return; // prevent double clicks
    this.isProcessing = true;

    const selectedAddress = this.addressDetails.find(
      (address) => address.isDefault === true,
    );
    const addressId = selectedAddress ? selectedAddress._id : null;

    const finalAmount = this.getFinalAmount(); // ✅ ALWAYS compute final price

    const para = {
      address_id: addressId,
      payment_gateway: paymentMethod,
      accept: true,
      shipping_charge:
        this.cartData?.product_id?.priceInventoryShippingInfo?.sippingCharge ||
        0,
      coupon_amount: this.discountPrice,
      coupon_code: this.couponCode,
      final_amount: finalAmount, // ✅ SEND DISCOUNTED PRICE
      online_discount: this.selectOption === 'online' ? 40 : 0,
      direct_purchase: false, // Set to true for direct purchase
      // product_id: this.cartData?.[0]?.product_id?._id , // Replace with actual product ID for direct purchase
      // quantity: 2, // Replace with actual quantity for direct purchase
      selected_items: this.cartData.map((item: any) => item.product_id._id), // For cart purchase
    };

    if (paymentMethod === 'COD') {
      this.onlyOnce = true;
      this.cancelOnlinePayment();
    }

    this.loader.showLoader();
    this.api.chackOut(para).subscribe((res: any) => {
      if (res) {
        console.log('checkout response:', res);
        this.loader.hideLoader();
        this.router.navigate(['order-sumamary'], {
          queryParams: { id: res.data?._id },
        });
      } else {
        this.isProcessing = false; // re-enable button
      }
    });
  }

  cancelOnlinePayment() {
    // Fire a custom postMessage event to simulate a cancel action
    const iframe = document.getElementById('paymentFrame') as HTMLIFrameElement;

    if (iframe) {
      const cancelMessage = {
        action: 'cancel', // Define your cancel action
        reason: 'User selected COD', // Optional: Add a reason
      };

      // Send a cancel message to the iframe
      iframe.contentWindow?.postMessage(
        JSON.stringify(cancelMessage),
        'https://mercury-t2.phonepe.com',
      );
    }
  }
}
